import { render } from "./NotificationTester.vue?vue&type=template&id=a53e162e"
import script from "./NotificationTester.vue?vue&type=script&lang=js"
export * from "./NotificationTester.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__